export const dashHome = {
  index: {
    boxes: {
      reservas: "Reservas",
      checkins: "Check-ins",
      ocupacion: "Ocupação",
      facturacion: "Receita",
      ingresosTotal: "Receita total",
      saldos: "Saldos pendentes",
      solicitudes: "Solicitações de IA",
      facturas: "Faturas pendentes",
      acciones: "Ações pendentes",
      salen: "Saem hoje",
      llegadas: "Próximas chegadas",
      ingresosDesglose: "Detalhamento da receita",
    },
    editToolbar: {
      done: "Concluído",
      addBox: "Adicionar bloco",
      reset: "Redefinir",
      hint: "Arraste para mover · puxe o canto para redimensionar",
      allBoxesVisible: "Todos os blocos estão visíveis.",
      removeTitle: "Remover",
      showOnboarding: "Mostrar o aviso de configuração",
    },
  },
  arrivals: {
    viewAll: "Ver todas as chegadas",
  },
  todayLeaving: {
    title: "Hóspedes que fazem check-out hoje",
    subtitle: "Check-outs agendados para hoje.",
    empty: "Nenhum hóspede fazendo check-out hoje.",
    loading: "Carregando os check-outs de hoje…",
    balance: "Saldo",
    balanceDueTitle: "Saldo a pagar: {amount} {currency}",
    paid: "Pago",
    paidTitle: "Reserva paga",
    viewAll: "Ver todos os check-outs",
  },
  mobileNotice: {
    sheetAriaLabel: "Baixe o app da WACheckin",
    closeAriaLabel: "Fechar",
    title: "Aproveite ao máximo a WACheckin",
    desc: "O painel foi projetado para <b>desktop</b>. No celular você tem um resumo; para gerenciar <b>todos os recursos</b> com conforto, abra no seu computador ou baixe nosso <b>app</b>.",
    appStorePrefix: "Baixe na",
    googlePlayPrefix: "Disponível no",
    continueOnMobile: "Continuar no celular",
  },
};